import React from 'react';

import { useUiComponentsInternationalContext } from '@rsc/static-translations';

export default function SkipToContent() {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <a
      href="#content"
      className="bg-secondary text-secondary-foreground-aa absolute -top-10 left-0 px-4 py-2 focus:top-0 focus:z-50 focus:outline-none rounded-br shadow"
    >
      {tt(s => s.skipToContentComponent.skipToContentLinkButton)}
    </a>
  );
}
